export default "__VITE_ASSET__FL6XynDV__"